import React from "react";
import { Grid } from "@mui/material";

export default function GridThemeColorComponent({ color }: {
    color: string | null,
}) {

    return (<Grid item
        sx={{
            mx: .5,
            height: '20px', width: '20px', borderRadius: '4px',
            backgroundColor: color
        }}
    >
    </Grid>)
}